<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            model="searchForm"
            key-property="accountId"
            search-url="/notify/listAllPopup"
            create-url="/notify/save"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            custom-class-item
            @classItem="openClassDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="false"
            :accept-edit="true"
            :accept-create="false"
            @viewItem="viewItem"
            @openLinkNewTap = "openLinkNewTap"
            @showImage="showImage"
            @showImage1="showImage1"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/notifyMKT/PopupMktCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "List popup config",
      formCreateName: "Thêm mới học sinh",
      className: null,
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      searchUrl:null,
      accountId:null,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "No",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'type',
          text: 'Type',
          search: true,
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'imgBackground',
          text: 'Img Background',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'imgClose',
          text: 'Image Close',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'voicePath',
          text: 'Voice',
          sortable: false,
          search: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'updatedAt',
          text: 'Date Time',
          width: "5%",
          type: "date",
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy hh:mm',
          headerStyle: "text-align:center",
        },
        {
          value: 'custom_action_list',
          width: "5%",
          text: 'View img background',
          headerStyle: "text-align:center;",
          items: [
            {
              icon: "visibility",
              event: "showImage",
              color: "primary"
            },
          ],
        },

        {
          value: 'custom_action_list',
          width: "5%",
          text: 'View img close',
          headerStyle: "text-align:center;",
          items: [
            {
              icon: "visibility",
              event: "showImage1",
              color: "primary"
            },
          ],
        },
        {
          value: 'custom_action_list',
          width: "5%",
          text: 'View Voice',
          headerStyle: "text-align:center;",
          items: [
            {
              icon: "visibility",
              event: "openLinkNewTap",
              color: "primary"
            },
          ],
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          headerStyle: "text-align:center",
          width: "5%",
        },
      ],
    };
  },

  created() {
  },



  methods: {

    showImage(item) {
      window.open(item.imgBackground, '_blank').focus();
    },
    showImage1(item) {
      window.open(item.imgClose, '_blank').focus();
    },

    openLink(item) {
      var audio = new Audio(item.url);
      audio.play();
    },
    openLinkNewTap(item) {
      window.open(item.voicePath, '_blank', 'noreferrer');
    },

    openLinkimgBackground(item) {
      window.open(item.imgBackground, '_blank', 'noreferrer');
    },

    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới học sinh';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Update Popup ';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      /*const obj2 = this.$route.query;*/
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/accountDetail/view/' + item.accountId,
        //path: '/accountDetail/view/' + item.accountId,
        query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
